import React, { memo, useCallback, useRef, useState } from 'react';


/**
 * Drag and Drop component wrapper
 *
 * based on lib react-files-drag-and-drop
 * source: https://github.com/YelyseiLukin/react-files-drag-and-drop/blob/master/src/components/index.tsx
 *
 */
var FilesDragAndDrop = function (_a) {
    var onUpload = _a.onUpload, children = _a.children, acceptedFileFormats = _a.acceptedFileFormats, _b = _a.hoverText, hoverText = _b === void 0 ? 'Drop files here' : _b, onError = _a.onError, invalidFileFormatErrorLabel = _a.invalidFileFormatErrorLabel, disabled = _a.disabled;
    var _c = useState(false), dragging = _c[0], setDragging = _c[1];
    var drag = useRef(null);
    var handleDragOver = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
    }, []);
    var handleUpload = useCallback(function (file) {
        if (!file) {
            return;
        }
        if (acceptedFileFormats &&
            !acceptedFileFormats.some(function (format) {
                return file.name.toLowerCase().endsWith(format.toLowerCase());
            })) {
            onError === null || onError === void 0 ? void 0 : onError(invalidFileFormatErrorLabel);
            return;
        }
        onUpload(file);
        onError === null || onError === void 0 ? void 0 : onError(null);
    }, [acceptedFileFormats, onUpload, onError, invalidFileFormatErrorLabel]);
    var handleDrop = useCallback(function (event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        setDragging(false);
        var file = (_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files[0];
        if (!file) {
            return;
        }
        handleUpload(file);
    }, [handleUpload]);
    var handleDragEnter = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target === drag.current) {
            return;
        }
        setDragging(true);
    }, []);
    var handleDragLeave = useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.target !== drag.current) {
            return;
        }
        setDragging(false);
    }, []);
    if (disabled) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { className: 'FilesDragAndDrop', onDragOver: handleDragOver, onDrop: handleDrop, onDragEnter: handleDragEnter, onDragLeave: handleDragLeave },
        dragging && (React.createElement("div", { ref: drag, className: 'dragging-overlay' }, hoverText)),
        children));
};
export default memo(FilesDragAndDrop);
